<template>
  <div class="home">
    <section class="home--section-left">
      <a :href="bannerUrl" target="_blank" class="home__link">
        <v-img
          v-if="['S002', 'S003'].includes($route.params && $route.params.code)"
          :src="require(`@/assets/images/bannerS002.png`)"
          position="top center"
          max-width="100%"
          height="100vh"
        />
        <v-img
          v-else
          :src="require(`@/assets/images/banner.jpg`)"
          position="top center"
          max-width="100%"
          height="100vh"
        />
      </a>
    </section>
    <section class="home--section-right pa-4 pa-sm-6 pa-lg-8">
      <div class="home__container">
        <header class="home__container__header">
          <div class="home__container__header__left">
            <a href="https://www.rossignol.com/" target="_blank">
              <img :src="require('@/assets/images/logo-rossignol.svg')" alt="Rossignol" />
            </a>
          </div>
        </header>
        <div class="home__container__main">
          <div class="home__container__main__intro text-center mt-12">
            {{ $t('home.intro') }}
          </div>
          <h1
            v-if="$route.params && $route.params.code === 'S032'"
            class="home__container__main__title text-center mt-4"
          >
            {{ $t('home.titleCA') }}
          </h1>
          <h1
            v-else-if="['S002', 'S003'].includes($route.params && $route.params.code)"
            class="home__container__main__title text-center mt-4"
          >
            {{ $t('home.titleS002') }}
          </h1>
          <h1 v-else class="home__container__main__title text-center mt-4">{{ $t('home.title') }}</h1>
          <div class="home__container__main__separator" v-if="$t('home.separator')">
            <span class="home__container__main__separator__label px-4">{{ $t('home.separator') }}</span>
          </div>
          <div
            v-if="$route.params && $route.params.code === 'S032'"
            class="home__container__main__caption text-center"
            v-html="$t('home.captionCA')"
          ></div>
          <div
            v-else-if="$route.params && $route.params.code === 'S020'"
            class="home__container__main__caption text-center"
            v-html="$t('home.captionNOK9000')"
          ></div>
          <div v-else class="home__container__main__caption text-center" v-html="$t('home.caption')"></div>
          <div
            v-if="$route.params && $route.params.code === 'S032'"
            class="home__container__main__prices text-center mt-6"
            v-html="$t('home.pricesCA')"
          ></div>
          <div v-else class="home__container__main__prices text-center mt-6" v-html="$t('home.prices')"></div>
          <v-btn
            depressed
            color="secondary"
            tile
            x-large
            height="54"
            :href="linkHref"
            class="home__container__main__link text-h6 mt-8"
          >
            {{ $t('home.cta') }}
          </v-btn>
        </div>
        <div class="home__container__language mt-6">
          <div class="home__container__language__label mb-2">{{ $t('home.language.label') }}</div>

          <v-select
            class="home__container__language__label__selector"
            :items="items"
            v-model="currentLanguage"
            outlined
            hide-details
            solo
            @change="onChange"
          >
            <template v-slot:selection="{ item }">
              <span class="d-flex justify-center text-uppercase" style="width: 100%">
                {{ item.text }}
              </span>
            </template>
          </v-select>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data: vm => ({
    currentLanguage: vm.$i18n.locale,
    hrefOverrides: {
      en: {
        S002: 'https://rossi-experience-en.gtr.cx/?g=paris-rossi-en',
        S003: 'https://rossi-experience-en.gtr.cx/?g=paris-rossi-en',
      },
      fr: {
        S002: 'https://rossi-experience-fr.gtr.cx/?g=paris-rossi-fr',
        S003: 'https://rossi-experience-fr.gtr.cx/?g=paris-rossi-fr',
      },
      it: {
        S002: 'https://rossi-experience-it.gtr.cx/?g=paris-rossi-it',
        S003: 'https://rossi-experience-it.gtr.cx/?g=paris-rossi-it',
      },
      de: {
        S002: 'https://rossi-experience-de.gtr.cx/?g=paris-rossi-de',
        S003: 'https://rossi-experience-de.gtr.cx/?g=paris-rossi-de',
      },
      es: {
        S002: 'https://rossi-experience-es.gtr.cx/?g=paris-rossi-es',
        S003: 'https://rossi-experience-es.gtr.cx/?g=paris-rossi-es',
      },
    },
  }),
  metaInfo: vm => ({
    title: vm.$t('meta.title'),
    meta: [{ name: 'description', content: vm.$t('meta.description') }],
  }),
  computed: {
    itemByLocale() {
      return this.items.find(item => item.value === this.currentLanguage)
    },
    linkHref() {
      const item = this.itemByLocale
      return item.href
    },
    bannerUrl() {
      const item = this.itemByLocale
      return item.website
    },
    items() {
      return [
        {
          text: 'English',
          value: 'en',
          href:
            this.hrefOverrides.en[this.$route.params.code] ||
            `https://rossi-love-en.gtr.cx/?g=ROS${this.$route.params.code}${this.$i18n.locale.toUpperCase()}`,
          website:
            'https://www.rossignol.com/uk/?utm_source=automation&utm_medium=email&utm_campaign=[EMA_AUT_ALL_EN]_trg-welcome-GTR-retail_all&utm_content=news_B2C_TRG-Welcome-GTR-Retail_EN_ROSSI',
        },
        {
          text: 'Français',
          value: 'fr',
          href:
            this.hrefOverrides.fr[this.$route.params.code] ||
            `https://rossi-love-fr.gtr.cx/?g=ROS${this.$route.params.code}${this.$i18n.locale.toUpperCase()}`,
          website:
            'https://www.rossignol.com/fr/?utm_source=automation&utm_medium=email&utm_campaign=[EMA_AUT_ALL_FR]_trg-welcome-GTR-retail_all&utm_content=news_B2C_TRG-Welcome-GTR-Retail_FR_ROSSI',
        },
        {
          text: 'Italiano',
          value: 'it',
          href:
            this.hrefOverrides.it[this.$route.params.code] ||
            `https://rossi-love-it.gtr.cx/?g=ROS${this.$route.params.code}${this.$i18n.locale.toUpperCase()}`,
          website:
            'https://www.rossignol.com/it/?utm_source=automation&utm_medium=email&utm_campaign=[EMA_AUT_ALL_IT]_trg-welcome-GTR-retail_all&utm_content=news_B2C_TRG-Welcome-GTR-Retail_IT_ROSSI',
        },
        {
          text: 'Deutsch',
          value: 'de',
          href:
            this.hrefOverrides.de[this.$route.params.code] ||
            `https://rossi-love-de.gtr.cx/?g=ROS${this.$route.params.code}${this.$i18n.locale.toUpperCase()}`,
          website:
            'https://www.rossignol.com/de/?utm_source=automation&utm_medium=email&utm_campaign=[EMA_AUT_ALL_DE]_trg-welcome-GTR-retail_all&utm_content=news_B2C_TRG-Welcome-GTR-Retail_DE_ROSSI',
        },
        {
          text: 'Español',
          value: 'es',
          href:
            this.hrefOverrides.es[this.$route.params.code] ||
            `https://rossi-love-es.gtr.cx/?g=ROS${this.$route.params.code}${this.$i18n.locale.toUpperCase()}`,
          website:
            'https://www.rossignol.com/es/?utm_source=automation&utm_medium=email&utm_campaign=[EMA_AUT_ALL_ES]_trg-welcome-GTR-retail_all&utm_content=news_B2C_TRG-Welcome-GTR-Retail_ES_ROSSI',
        },
      ]
    },
  },
  methods: {
    onChange(locale) {
      this.$i18n.locale = locale
    },
    logoByLocale(param) {
      const item = this.itemByLocale
      return item.logo ? item.logo[param] : null
    },
  },
}
</script>

<style lang="scss">
.home {
  display: flex;
  min-height: 100%;

  &--section-left {
    display: none;
    position: fixed;

    @media (min-width: map-get($grid-breakpoints, 'md')) {
      display: flex;
      width: calc(100% - 600px);
    }

    @media (min-width: map-get($grid-breakpoints, 'lg')) {
      width: calc(100% - 900px);
    }

    @media (min-width: map-get($grid-breakpoints, 'xl')) {
      width: calc(100% - 1100px);
    }

    @media (min-width: map-get($grid-breakpoints, 'xxl')) {
      width: calc(100% - 1300px);
    }
  }

  &__link {
    max-width: 100%;
  }

  &--section-right {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: $color-bg;
    width: 100%;

    @media (min-width: map-get($grid-breakpoints, 'md')) {
      margin-left: calc(100% - 600px);
      width: 600px;
    }

    @media (min-width: map-get($grid-breakpoints, 'lg')) {
      margin-left: calc(100% - 900px);
      width: 900px;
    }

    @media (min-width: map-get($grid-breakpoints, 'xl')) {
      margin-left: calc(100% - 1100px);
      width: 1100px;
    }

    @media (min-width: map-get($grid-breakpoints, 'xxl')) {
      margin-left: calc(100% - 1300px);
      width: 1300px;
    }
  }

  &__logo {
    position: absolute;
    bottom: $gutter-tablet;
    left: $gutter-tablet;

    @media (min-width: map-get($grid-breakpoints, 'lg')) {
      bottom: $gutter-desktop;
      left: $gutter-desktop;
    }
  }

  &__container {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    width: 100%;

    @media (min-width: map-get($grid-breakpoints, 'sm')) {
      justify-content: space-between;
      max-width: 550px;
    }

    &__header {
      display: grid;
      grid-template-columns: repeat(1, 1fr);
      grid-gap: 32px;

      &__left,
      &__center,
      &__right {
        display: flex;
        position: relative;
        justify-content: center;

        a {
          display: inline-flex;

          img {
            max-width: 100%;
            height: 60px;
          }
        }
      }

      &__center {
        &:before {
          position: absolute;
          top: 50%;
          left: -16px;
          transform: translateY(-50%);
          background-color: rgba($color-text-main, 0.8);
          width: 2px;
          height: 70%;
          content: '';
        }
      }
    }

    &__main {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-transform: uppercase;

      &__intro {
        text-transform: initial;
        font-size: 1.375rem;
      }

      &__title {
        color: $color-text-accent;
        font-size: 1.875rem;
        font-weight: bold;

        @media (min-width: map-get($grid-breakpoints, 'sm')) {
          font-size: 2.5rem;
        }
      }

      &__separator {
        position: relative;
        width: 100%;
        text-align: center;
        color: $color-text-main;
        font-size: 1.5rem;
        font-weight: bold;

        @media (min-width: map-get($grid-breakpoints, 'sm')) {
          font-size: 1.75rem;
        }

        &:before {
          position: absolute;
          top: 50%;
          right: 0;
          left: 0;
          transform: translateY(-50%);
          background-color: rgba($color-text-main, 0.7);
          height: 2px;
          content: '';
        }

        &__label {
          position: relative;
          background-color: $color-bg;
        }
      }

      &__subtitle {
        text-transform: uppercase;
        color: $color-text-accent;
        font-size: 1.7rem;
        font-weight: bold;

        @media (min-width: map-get($grid-breakpoints, 'sm')) {
          font-size: 2.25rem;
        }
      }

      &__caption {
        color: $color-text-main;
        font-size: 1.25rem;

        @media (min-width: map-get($grid-breakpoints, 'sm')) {
          font-size: 1.75rem;
        }
      }

      &__prices {
        text-transform: initial;
        color: $color-text-alt;

        a {
          color: $color-text-alt !important;
        }
      }

      &__link {
        font-weight: bold;
      }
    }

    &__language {
      display: flex;
      flex-direction: column;
      align-items: center;

      &__label {
        text-transform: uppercase;
        color: $color-text-main;
        font-size: 1.25rem;

        @media (min-width: map-get($grid-breakpoints, 'sm')) {
          font-size: 1.5rem;
        }
      }
    }
  }
}
</style>
